import type { GetWithdrawRequestsParams } from '../types/withdrawRequestsTypes'

export const withdrawRequestKeys = {
  all: ['treasury', 'withdrawRequests'] as const,

  lists: () => [...withdrawRequestKeys.all, 'list'] as const,
  list: (filters: GetWithdrawRequestsParams) => [...withdrawRequestKeys.lists(), filters] as const,

  details: () => [...withdrawRequestKeys.all, 'detail'] as const,
  detail: (id: string) => [...withdrawRequestKeys.details(), id] as const,

  statusCounts: () => [...withdrawRequestKeys.all, 'statusCounts'] as const,
}
